<template>
  <FormInputGroup
    data-el="form-input-read"
    :data-editing="isEditing ? '1' : '0'"
    :data-id="dataId"
    :data-value="value"
  >
    <FormInput
      v-if="!isEditing"
      :value="value"
      readonly
      :size="size"
      disabled
      copy
      in-group
      data-id="fir-value"
    />
    <FormInput
      v-else
      :value="valueF"
      :size="size"
      data-id="fir-valuef"
      copy
      in-group
      @change="onValueFChange"
    />
    <Btn
      v-if="editable && !isEditing"
      tag="button"
      :size="size"
      :variant="Variant.white"
      in-group
      icon="edit"
      data-id="fir-edit"
      title="Edit"
      @click="isEditing = true"
    />
    <Btn
      v-if="isEditing"
      tag="button"
      :size="size"
      :variant="Variant.white"
      in-group
      title="Save"
      icon="save"
      data-id="fir-save"
      @click="save"
    />
    <Btn
      v-if="editable && isEditing"
      data-id="fir-cancel"
      tag="button"
      :size="size"
      :variant="Variant.white"
      in-group
      icon="close"
      title="Cancel"
      @click="isEditing = false"
    />
    <CopyButton
      v-if="!isEditing"
      :value="value"
      :size="size"
      data-id="fir-copy"
      in-group
      :variant="Variant.white"
    />
  </FormInputGroup>
</template>
<script setup lang="ts">
import FormInputGroup from '../../components/form/FormInputGroup.vue';
import FormInput from '../../components/form/FormInput.vue';
import CopyButton from '../../components/CopyButton.vue';
import { Variant } from '../../store/types';
import Btn from '../../components/form/Btn.vue';
import { ref, watch } from 'vue';
import type { FormSize } from '../../lib/services/types';

const props = withDefaults(
  defineProps<{
    dataId: string;
    value: string;
    editable?: boolean;
    size: FormSize;
  }>(),
  { size: 'md', editable: false },
);
const valueF = ref(props.value);
const onValueFChange = (v: string) => {
  valueF.value = v;
};
const emit = defineEmits<{ (e: 'change', p: string): void }>();
const save = () => {
  emit('change', valueF.value);
};
const isEditing = ref(false);
watch(
  () => props.value,
  (v) => {
    valueF.value = v;
  },
);
</script>
